import { Button, Col, Modal, Row } from "antd";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormActionValidate, {
  formNameActionValidate,
} from "../../components/forms/FormActionValidate/FormActionValidate";
import useSubmitValidate from "../../components/forms/FormActionValidate/useSubmitValidate";
import FormMarkAsPerformed, {
  formNameMarkAsPerformed,
} from "../../components/forms/FormMarkAsPerformed/FormMarkAsPerformed";
import useSubmitMarkAsPerformed from "../../components/forms/FormMarkAsPerformed/useSubmitMarkAsPerformed";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import spacing from "../../components/ui/spacingConfig";
import { useFetchActionQuery } from "../../features/api/apiSlice";
import { useModal } from "../../features/modals/useModal";
import { useRole } from "../../features/roles/useRole";
import CardDescription from "./components/CardDescriptionAction";
import styles from "./PageAction.module.scss";
import { modalProps } from "../../features/modals/modalProps";

const PageAction = () => {
  const { isPilote } = useRole();
  const { id, eventId } = useParams<{ id: string; eventId: string }>();

  const {
    data: actionData,
    isFetching,
    refetch,
  } = useFetchActionQuery(id, {
    skip: !id,
  });

  /**
   * "Mark performed" modal logic
   */
  const { onShowModal, isModalOpen, onHideModal } = useModal();
  const { onSubmit, isLoading: isMarkingActionPerformed } =
    useSubmitMarkAsPerformed({
      id: Number(id),
      onSuccess: () => {
        onHideModal();
        refetch();
      },
    });

  /**
   * "Validate/refuse" modal logic
   */
  const {
    onShowModal: onShowValidateModal,
    isModalOpen: isValidateModalOpen,
    onHideModal: onHideValidateModal,
  } = useModal();
  const { onSubmit: onSubmitValidate, isLoading: isValidating } =
    useSubmitValidate({
      id: Number(id),
      onSuccess: () => {
        onHideValidateModal();
        refetch();
      },
    });

  /**
   * Navigation handlers
   */
  const navigate = useNavigate();
  const navigateToEdit = useCallback(() => {
    navigate(`/events/${eventId}/actions/${id}/edit`);
  }, [id, eventId, navigate]);

  console.log("actionData", actionData);

  const isPageLoading = isFetching || isValidating;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Row justify="space-between" align="middle">
        {!isFetching && (
          <Col>
            <Breadcrumbs
              pageName="action"
              actionName={actionData?.title}
              actionId={actionData?.id}
              eventName={actionData?.eventName}
              eventId={actionData?.eventId}
            />
          </Col>
        )}
        <Row gutter={spacing.m} className={styles.buttonsContainer}>
          {isPilote && (
            <Col>
              <Button type="primary" onClick={navigateToEdit}>
                Modifier
              </Button>
            </Col>
          )}

          <Col>
            <Button
              type="primary"
              onClick={onShowModal}
              disabled={
                actionData?.status !== "AFFECTED" &&
                actionData?.status !== "REFUSED"
              }
            >
              Cloturer
            </Button>
          </Col>
          {isPilote && (
            <Col>
              <Button
                type="primary"
                onClick={onShowValidateModal}
                disabled={actionData?.status !== "PERFORMED"}
              >
                Valider / Refuser
              </Button>
            </Col>
          )}
        </Row>
      </Row>
      <CardDescription
        actionData={actionData}
        className={styles.cardsEventDetail}
      />

      {/* 
        Modal: "Cloturer"
      */}
      <Modal
        {...modalProps}
        title={<p>Cloturer</p>}
        footer={
          <>
            <Button
              type="default"
              onClick={onHideModal}
              disabled={isMarkingActionPerformed}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={false}
              loading={isMarkingActionPerformed}
              form={formNameMarkAsPerformed}
            >
              Cloturer
            </Button>
          </>
        }
        loading={isMarkingActionPerformed}
        open={isModalOpen}
        onCancel={onHideModal}
      >
        <FormMarkAsPerformed onSubmit={onSubmit} />
      </Modal>
      {/* 
        Modal: "Valider / Refuser"
      */}
      <Modal
        {...modalProps}
        title={<p>Valider / Refuser</p>}
        footer={
          <>
            <Button
              type="default"
              onClick={onHideValidateModal}
              disabled={isMarkingActionPerformed}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={false}
              loading={isValidating}
              form={formNameActionValidate}
            >
              Soumettre
            </Button>
          </>
        }
        loading={isValidating}
        open={isValidateModalOpen}
        onCancel={onHideValidateModal}
      >
        <FormActionValidate onSubmit={onSubmitValidate} />
      </Modal>
    </PageLayout>
  );
};

export default PageAction;
